import { ChangeDetectionStrategy, Component, computed, inject, OnInit, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DashboardDialogFramePart, DialogAction, DialogContext, DialogService } from '@eforall/dashboard';
import { TabStripModule } from '@progress/kendo-angular-layout';
import { ReadonlyAccessWidget } from 'ui/widget/readonly-access/readonly-access.widget';
import { VolunteerDialog } from '../../volunteer-dialog';
import { SpecialistSignUpNoteEditorDialog } from '../specialist-sign-up-note-editor/specialist-sign-up-note-editor.dialog';
import { SpecialistSignUpDetailsPart } from './details/details.part';
import { SpecialistSignUpEventsPart } from './events/events.part';
import { SpecialistSignUpViewerDialogDataService } from './specialist-sign-up-viewer-dialog-data.service';
@Component({
	selector: 'programs-specialist-sign-up-viewer-dialog',
	standalone: true,
	imports: [
		DashboardDialogFramePart,
		ReadonlyAccessWidget,
		TabStripModule,
		SpecialistSignUpDetailsPart,
		SpecialistSignUpEventsPart
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './specialist-sign-up-viewer.dialog.html',
})

export class SpecialistSignUpViewerDialog implements OnInit {

	public dialogRef = inject(MatDialogRef<SpecialistSignUpViewerDialog>);
	public dialogContext: DialogContext<{ volunteerSignupSpecialistId: number }> = inject(MAT_DIALOG_DATA);

	private readonly dialogService = inject(DialogService);
	public readonly dialogDataservice = inject(SpecialistSignUpViewerDialogDataService);

	public readonly headerTitle = computed(() => `Specialist Sign-up: ${this.dialogDataservice.specialistSignUpDetails()?.person.fullName}`);

	async ngOnInit() {
		const data = this.dialogContext.data;
		if (data?.volunteerSignupSpecialistId)
			await this.dialogDataservice.getVolunteerSignupSpecialistData(data.volunteerSignupSpecialistId);
	}

	public actions = computed<DialogAction[]>(() => {

		const specialistSignUpDetails = this.dialogDataservice.specialistSignUpDetails();
		if (!specialistSignUpDetails) return [];

		return [{
			id: 'editSignUp',
			cssClass: signal('btn-standard'),
			enabled: signal(this.dialogDataservice.canEdit()),
			visible: signal(true),
			text: signal('Edit Note'),
			linkType: "callback",
			willCloseDialog: false,
			callback: async () => {
				await this.dialogService.showCustom(SpecialistSignUpNoteEditorDialog, { data: specialistSignUpDetails }, 500, 300);
				await this.dialogDataservice.getVolunteerSignupSpecialistData(specialistSignUpDetails.volunteerSignupSpecialistId);
			}
		},
		{
			id: 'viewVolunteerDetails',
			cssClass: signal('btn-standard'),
			enabled: signal(true),
			visible: signal(true),
			text: signal('View Volunteer Details'),
			linkType: "callback",
			willCloseDialog: false,
			callback: async () => {
				await this.dialogService.showCustom(VolunteerDialog, { data: { volunteerId: specialistSignUpDetails.volunteerId } }, 900, 900);
				await this.dialogDataservice.getVolunteerSignupSpecialistData(specialistSignUpDetails.volunteerSignupSpecialistId);
			}
		},
		{
			id: 'close',
			cssClass: signal('undefined'),
			enabled: signal(true),
			visible: signal(true),
			text: signal('Close'),
			linkType: "no-action",
			willCloseDialog: true,
		}];
	});

}